import http from "@/utils/http"

// 消息列表
//   GET /crm/notification
//   接口ID：367328389
//   接口地址：https://app.apifox.com/link/project/4770011/apis/api-367328389
export function list(params): Promise<any> {
  return http.get("/api/v1/crm/notification", { params })
}

// 获取未读条数
//   GET /crm/notification/unread_count
//   接口ID：367333411
//   接口地址：https://app.apifox.com/link/project/4770011/apis/api-367333411
export function unreadCount(): Promise<any> {
  return http.get("/api/v1/crm/notification/unread_count")
}

// 标记已读
//   PUT /crm/notification/{id}/mark_read
//   接口ID：367333680
//   接口地址：https://app.apifox.com/link/project/4770011/apis/api-367333680
export async function markRead(id): Promise<any> {
  return http.put(`/api/v1/crm/notification/${id}/mark_read`)
}
// 全部已读
//   PUT /crm/notification/mark_read_all
//   接口ID：367333686
//   接口地址：https://app.apifox.com/link/project/4770011/apis/api-367333686
export async function markReadAll(): Promise<any> {
  return http.put(`/api/v1/crm/notification/mark_read_all`)
}
// 删除
//   DELETE /crm/notification/{id}
//   接口ID：367333689
//   接口地址：https://app.apifox.com/link/project/4770011/apis/api-367333689
export async function del(id): Promise<any> {
  return http.delete(`/api/v1/crm/notification/${id}`)
}
// 删除已读
//   DELETE /crm/notification/delete_read
//   接口ID：367333691
//   接口地址：https://app.apifox.com/link/project/4770011/apis/api-367333691

export async function delAll(): Promise<any> {
  return http.delete(`/api/v1/crm/notification/delete_read`)
}
